import React from 'react';
import './DatePicker.css'

class DatePicker extends React.Component{
  constructor(props){
      super(props)
      this.state = {
          day:"",
          month:"",
          year:"",
          data:"",
          blankInit: this.props.blankInit?true:false
      }
  }

  componentWillMount() {
      
  }

  componentDidMount() {
      const date = new Date()
      const day = this.props.blankInit?"":date.getDate()
      const year = this.props.year?this.props.year:this.props.blankInit?"":date.getFullYear();
      const month = this.props.blankInit?"":this.getMonths()[date.getMonth()]
      const fullDate = this.props.blankInit?"":day+" "+month+" "+year;
      this.setState({
          data:fullDate,
          day:day,
          month:month,
          year:year
      });
  }
  

  getYears(toYear){
    const years = [];
    const date = new Date();
    const year = date.getFullYear();
    for(let x=year;x>=toYear;x--){
        years.push(x)
    }

    return years;
  }

  getMonths(){
    return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July ',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
  }

  getDays(){
    const days = [];
    for(let x=1;x<=31;x++){
        days.push(x)
    }

    return days;
  }
  
  render(){
    return(
      <div className={(!this.props.withMonth && !this.props.withDay)?"dp-ui just-year":(this.props.withMonth && !this.props.withDay)?"dp-ui month-year":"dp-ui"} data-value={this.state.data}>
        { this.props.withDay &&
            <div className="dp-ui-field days" tabIndex="0" ref={(ref)=>{
                    this.dayField = (ref===null)?this.dayField:ref
                }} onMouseLeave={()=>{
                    this.dayField.blur()
                }}>
                <div className="dp-ui-field-btn">
                    <span>{this.state.blankInit?"":this.state.day}</span>
                </div>
                <div className="dp-ui-field-content">
                    {
                        this.getDays().map((item,i)=>{
                            return(
                                <span key={i} className="dp-ui-field-content-value" onClick={()=>{
                                        const val = (this.props.withYear)?item+" "+this.state.month+" "+this.state.year:((this.props.withMonth)?item+" "+this.state.month:item);
                                         this.setState({
                                            day:item,
                                            data:val,
                                            blankInit: false
                                        });
                                        if(isValidDate(item, this.getMonths().indexOf(this.state.month), this.state.year)){
                                            this.props.onChangeDate(val)
                                        }
                                        this.dayField.blur()
                                    }}>{item}</span>
                            )
                        })
                    }
                </div>
            </div>
        }
        {   this.props.withMonth &&
            <div className="dp-ui-field months" tabIndex="0" ref={(ref)=>{
                    this.monthField = (ref===null)?this.monthField:ref
                }} onMouseLeave={()=>{
                    this.monthField.blur()
                }}>
                <div className="dp-ui-field-btn">
                    <span>{this.state.blankInit?"":this.state.month}</span>
                </div>
                <div className="dp-ui-field-content">
                    {
                        this.getMonths().map((item,i)=>{
                            return(
                                <span key={i} className="dp-ui-field-content-value" onClick={()=>{
                                        const val = (this.props.withYear && this.props.withDay)?this.state.day+" "+item+" "+this.state.year:(this.props.withYear && !this.props.withDay)?item+" "+this.state.year:((this.props.withDay && !this.props.withYear)?this.state.day+" "+item:item);
                                        this.setState({
                                            month:item,
                                            data:val,
                                            blankInit: false
                                        });
                                        if(isValidDate(this.state.day, i, this.state.year)){
                                            this.props.onChangeDate(val)
                                        }
                                        this.monthField.blur()
                                    }}>{item}</span>
                            )
                        })
                    }
                </div>
            </div>
        }
        {   this.props.withYear &&
            <div className="dp-ui-field years" tabIndex="0" ref={(ref)=>{
                    this.yearField = (ref===null)?this.yearField:ref
                }} onMouseLeave={()=>{
                    this.yearField.blur()
                }}>
                <div className="dp-ui-field-btn">
                    <span>{this.state.blankInit?"":this.props.year?this.props.year:this.state.year}</span>
                </div>
                <div className="dp-ui-field-content">
                    {   this.props.andSomeValue &&
                        <span className="dp-ui-field-content-value" onClick={()=>{
                             const val = (this.props.withMonth && this.props.withDay)?this.state.day+" "+this.state.month+" "+this.props.andSomeValue:this.props.andSomeValue;
                             this.setState({
                                 year:this.props.andSomeValue,
                                 data:val,
                                 blankInit: false
                            });
                            if(isValidDate(this.state.day, this.getMonths().indexOf(this.state.month), this.props.andSomeValue)){
                                this.props.onChangeDate(val)
                            }
                            this.yearField.blur()
                            }}>
                            {this.props.andSomeValue}
                        </span>
                    }
                    {!this.props.year &&
                        this.getYears(1940).map((item,i)=>{
                            return(
                                <span key={i} className="dp-ui-field-content-value" onClick={()=>{
                                        
                                        const val = (this.props.withMonth && this.props.withDay)?this.state.day+" "+this.state.month+" "+item:(this.props.withMonth && !this.props.withDay)?this.state.month+" "+item:item;
                                        this.setState({
                                            year:item,
                                            data:val,
                                            blankInit: false
                                        });
                                        if(isValidDate(this.state.day, this.getMonths().indexOf(this.state.month), item)){
                                            this.props.onChangeDate(val)
                                        }
                                        this.yearField.blur()
                                    }}>{item}</span>
                            )
                        })
                    }
                    {this.props.year &&
                        <span className="dp-ui-field-content-value disabled" onClick={()=>{
                                            
                            const val = (this.props.withMonth && this.props.withDay)?this.state.day+" "+this.state.month+" "+this.props.year:(this.props.withMonth && !this.props.withDay)?this.state.month+" "+this.props.year:this.props.year;
                            this.setState({
                                year:this.props.year,
                                data:val,
                                blankInit: false
                            });
                            if(isValidDate(this.state.day, this.getMonths().indexOf(this.state.month), this.props.year)){
                                this.props.onChangeDate(val)
                            }
                            this.yearField.blur()
                        }}>{this.props.year}</span>
                    }
                </div>
            </div>
        }
      </div>
    )
  }
}

/**
 * Get the number of days in any particular month
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {integer} m The month (valid: 0-11)
 * @param  {integer} y The year
 * @return {integer}   The number of days in the month
 */

var daysInMonth = function (m, y) {
    switch (m) {
        case 1 :
            return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
        case 8 : case 3 : case 5 : case 10 :
            return 30;
        default :
            return 31
    }
};

/**
 * Check if a date is valid
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {[type]}  d The day
 * @param  {[type]}  m The month
 * @param  {[type]}  y The year
 * @return {Boolean}   Returns true if valid
 */

var isValidDate = function (d, m, y) {
    m = parseInt(m, 10) - 1;
    return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker.js